import { useTranslation } from 'react-i18next'
import Layout from './Mobile/Layout'

export default function RunTimeError({ error }: { error: Error }) {
  const { t } = useTranslation()
  return (
    <Layout>
      <div className="text-center p-4">
        <div>
          {t('GENERIC_ERROR_OCCURRED')}
        </div>
      </div>
    </Layout>
  )
}
